/* Mirrors src/constants/theme.ts (Spacing.three/four/five, MaxContentWidth,
   SidebarWidth) and src/hooks/use-breakpoint.ts (Breakpoints.lg) — keep the
   numbers below in sync if those change.

   This picks the mobile/desktop layout with a plain media query instead of a
   JS-computed `isLg` flag, so the browser resolves it on first paint. The
   old approach rendered a completely different (unconstrained, single
   column) tree until client JS mounted and measured the window, which
   flashed a full-width mobile layout on every desktop load before snapping
   to the real one. */

.grid {
  box-sizing: border-box;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-areas:
    'hero'
    'filters'
    'nav'
    'events'
    'experiences'
    'boats'
    'articles'
    'feature'
    'content';
  gap: 24px;
  padding-top: 16px;
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: 256px 1fr;
    grid-template-areas:
      'filters hero'
      'filters nav'
      'filters events'
      'filters experiences'
      'filters boats'
      'filters articles'
      'filters feature'
      'filters content';
    max-width: 1280px;
    margin: 0 auto;
    padding: 24px;
    gap: 32px;
  }
}

.hero {
  grid-area: hero;
  min-width: 0;
}
.filters {
  grid-area: filters;
  min-width: 0;
}
.nav {
  grid-area: nav;
  min-width: 0;
}
.events {
  grid-area: events;
  min-width: 0;
}
/* The three sections below are populated client-side (Supabase for tours,
   Sanity for articles), so at first paint they're empty and everything under
   them jumps down when the data lands — Lighthouse attributed the homepage's
   0.111 CLS to exactly these three plus the hero stats row.
   `min-height` reserves each one's loaded height (measured from the rendered
   page at desktop width; the cards are fixed-size, so the same reservation
   holds at every breakpoint) so the content fills space that was already
   there. Keep these in sync if the card dimensions change. */
.experiences {
  grid-area: experiences;
  min-width: 0;
  min-height: 326px;
}
.boats {
  grid-area: boats;
  min-width: 0;
  min-height: 326px;
}
.articles {
  grid-area: articles;
  min-width: 0;
  min-height: 286px;
}
.feature {
  grid-area: feature;
  min-width: 0;
  min-height: 87px;
}
.content {
  grid-area: content;
  min-width: 0;
}
